// Switch.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './Switch.css';

/**
 * Switch
 *
 * Reusable on/off switch with theme-aware colors.
 *
 * @param {boolean} checked - Whether the switch is on.
 * @param {boolean} disabled - Whether the switch is disabled.
 * @param {function} onChange - Called with the next checked value when toggled.
 *
 * @returns {ReactNode} The rendered switch.
 */
const Switch = ({ checked = false, disabled = false, onChange }) => {

    // ----- CONTEXT ----- //

    // Theme Context

    const { theme } = useTheme();

    // ----- HANDLERS ----- //

    /**
     * Toggles the switch when it is enabled.
     */

    const handleToggle = () => {
        if (disabled) return;
        if (onChange) onChange(!checked);
    };

    // ----- RENDER ----- //

    return (
        <button
          className="switch-container"
          style={{
                backgroundColor: checked ? theme.highlight : theme.backgroundMuted,
                borderColor: checked ? theme.highlight : theme.foregroundMuted,
            }}
          type="button"
          role="switch"
          aria-checked={checked}
          aria-disabled={disabled}
          disabled={disabled}
          onClick={handleToggle}
        >
            {/* THUMB */}
            <span
              className="switch-thumb"
              style={{
                    backgroundColor: checked ? theme.highlightForeground : theme.foreground,
                    transform: checked ? 'translateX(20px)' : 'translateX(0px)',
                }}
            />
        </button>
    );
};

// Dev Tools
Switch.displayName = 'Switch';

export default Switch;
